export const USER_CONSTANT = {
    // テーブル名
    TABLE: 'view_user',
    
  };
  